import React from "react";
import { motion } from "framer-motion";

const TermsAndConditions = () => {
    return (
        <div className="terms-and-conditions-container">
            <motion.h2
                className="terms-heading"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                Terms and Conditions
            </motion.h2>

            <motion.div
                className="terms-content"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
            >
                <p className="terms-paragraph">
                    Welcome to V9PrimeForce.com. By accessing and using our website, you agree to comply with the following terms and conditions.
                </p>

                <h3>1. Acceptance of Terms</h3>
                <p className="terms-paragraph">
                    By accessing this website, you agree to be bound by these Terms and Conditions and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
                </p>

                <h3>2. Use of Website</h3>
                <p className="terms-paragraph">
                    You agree to use the website in compliance with all applicable laws and regulations, and you are solely responsible for your use of the site.
                </p>

                <h3>3. Intellectual Property</h3>
                <p className="terms-paragraph">
                    All content on V9PrimeForce.com, including text, images, graphics, logos, and software, is owned by V9PrimeForce and is protected by intellectual property laws.
                </p>

                <h3>4. User Responsibilities</h3>
                <p className="terms-paragraph">
                    You agree not to engage in activities that could harm or disrupt the website or interfere with other users' access to the site.
                </p>

                <h3>5. Privacy Policy</h3>
                <p className="terms-paragraph">
                    Your use of this website is also governed by our Privacy Policy, which can be found on our Privacy Policy page. Please review it to understand how we collect and use your information.
                </p>

                <h3>6. Limitation of Liability</h3>
                <p className="terms-paragraph">
                    V9PrimeForce.com will not be liable for any damages arising from the use of this website, including but not limited to direct, indirect, incidental, or consequential damages.
                </p>

                <h3>7. Governing Law</h3>
                <p className="terms-paragraph">
                    These Terms and Conditions are governed by the laws of India, and you agree to submit to the exclusive jurisdiction of the courts in India for any disputes arising from the use of this website.
                </p>

                <h3>8. Changes to Terms</h3>
                <p className="terms-paragraph">
                    V9PrimeForce reserves the right to update or modify these Terms and Conditions at any time. All changes will be posted on this page, and it is your responsibility to review the terms periodically.
                </p>

                <h3>9. Contact Information</h3>
                <p className="terms-paragraph">
                    If you have any questions about these Terms and Conditions, please contact us at support@v9primeforce.com.
                </p>
            </motion.div>
        </div>
    );
}

export default TermsAndConditions;
